var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Chats",
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 202.586,
    viewBox: "0 0 192 202.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1257",
    "data-name": "Trazado 1257",
    d: "M1050.667,202.6l-49.011,27.892A14.515,14.515,0,0,0,994.32,243.1v56.2a14.519,14.519,0,0,0,6.744,12.259l20.969,13.29v38.624l95.182-52.059a14.512,14.512,0,0,0,7.551-12.733V243.354a14.513,14.513,0,0,0-7.647-12.786l-52.4-28.143A14.511,14.511,0,0,0,1050.667,202.6Z",
    transform: "translate(-994.32 -200.697)",
    fill: "#ff4040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M1136.367,244.631l-42.787-24.352s.05,3.854.05,8.119v55.335a14.516,14.516,0,0,1-7.548,12.733l-59.239,32.4,89.146,48.757V339l20.967-13.289a14.513,14.513,0,0,0,6.744-12.259v-56.2A14.519,14.519,0,0,0,1136.367,244.631Z",
    transform: "translate(-951.7 -175.036)",
    fill: "#ff4040"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/Chats.05540d12b40f13baa1fdd60df3fa936a.svg";
export { ForwardRef as ReactComponent };